import { useState, useContext, useEffect } from "react";
import { verificaDni } from "../../../context/Actions/verificaDni/verificaDni";
import { logoutVerificaDni } from "../../../context/Actions/verificaDni/logoutVerificaDni";
import { PortalContext } from "../../../context/Provider";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import {
  setUsuario,
  setListError,
} from "../../../context/Actions/registro/registro";
import { logoutMultiTab } from "../../../context/Actions/multiTab/logoutMultiTab";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import {
  filtrarPorRegex,
  regexSoloDigitos,
} from "global/utils/inputValidators";
import {
  logoutPacienteDefault,
  wsGetCambioClave,
} from "../../../context/Actions/paciente/paciente";
import { showSegundoModal } from "../../../context/Actions/segundoModal/segundoModal";
import isDniValido from "../../../../global/utils/checkDniValido";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { GlobalContext } from "../../../../global/context/Provider";
import { IonSpinner } from "@ionic/react";

const CambioPasswordPaso1 = ({ titulo, dissmiss }) => {
  const {
    registroState,
    registroDispatch,
    verificaDniDispatch,
    modalDispatch,
    verificaDniState,
    multiTabDispatch,
    pacienteDispatch,
    segundoModalDispatch,
  } = useContext(PortalContext);

  const { toasterDispatch } = useContext(GlobalContext);

  const onlyNumbers = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      if (isDniValido(e)) {
        verificaDni(dni)(verificaDniDispatch);
      }
    }
  };
  const [dni, SetDni] = useState("");

  const verificandoDni = () => {
    if (
      !registroState.registro.listError.nro_documento &&
      registroState.registro.usuario.nro_documento !== ""
    ) {
      verificaDni(dni)(verificaDniDispatch);
    }
  };

  const onDniChange = (e) => {
    const valorNuevo = e.target.value;

    // Filtro genérico por regex: si lo que pegaron/escribieron no cumple,
    // no actualizo el estado ni el store. El input (controlado) se queda
    // con el último valor válido (y forzamos el DOM a ese valor).
    const { esValido, valorSanitizado } = filtrarPorRegex(
      valorNuevo,
      regexSoloDigitos
    );

    if (!esValido) {
      // Revertimos visualmente al último DNI válido
      e.target.value = dni;

      // Si el DNI actual ya es válido (7-9 dígitos), solo muestro toaster sin marcar error
      if (dni && dni.length >= 7 && dni.length <= 9) {
        showToaster(
          {
            texto: "Solo se permiten números",
            tipo: "info",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        // Solo marco error si el campo está vacío o incompleto
        let errx = { ...registroState.registro.listError };
        errx.nro_documento = true;
        setListError(errx)(registroDispatch);
      }
      return;
    }

    let errx = { ...registroState.registro.listError };
    errx.nro_documento = !isDniValido(e);
    setListError(errx)(registroDispatch);

    let usuario = { ...registroState.registro.usuario };
    usuario.nro_documento = valorSanitizado;
    SetDni(valorSanitizado);
    setUsuario(usuario)(registroDispatch);
  };

  const cleanDni = () => {
    logoutVerificaDni()(verificaDniDispatch);
    setTimeout(() => {
      hideModal()(modalDispatch);
    }, 250);
  };

  const solicitarCodigo = () => {
    let dni = registroState.registro.usuario.nro_documento;
    wsGetCambioClave(dni, changePaso)(pacienteDispatch);
  };

  const changePaso = (isCorrect, data) => {
    if (isCorrect) {
      if (data !== null && data !== undefined) {
        hideModal()(modalDispatch);
        showToaster(
          {
            texto: "Enviamos el código a su casilla de Email.",
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
        showModal(
          "Auth/CambioPassword/CambioPasswordPaso2",
          {
            dissmiss: cleanDni,
          },
          {},
          "centro",
          true
        )(modalDispatch);
      }
    } else {
      // Manejo de error normalizado con compatibilidad legacy
      if (data !== null && data !== undefined && data !== false) {
        // Usamos userMessage si está disponible, sino data (legacy)
        const mensajeError =
          data.userMessage ||
          data.data ||
          "Su código no pudo ser verificado, contáctese con el centro de atención al paciente";

        showToaster(
          {
            texto: mensajeError,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        hideModal()(modalDispatch);
        logoutPacienteDefault()(pacienteDispatch);
      }
    }
  };

  const crearNuevaCuenta = () => {
    logoutVerificaDni()(verificaDniDispatch);
    logoutMultiTab()(multiTabDispatch);
    hideModal()(modalDispatch);
    showSegundoModal(
      "Auth/Registracion/Registracion",
      {
        dissmiss: dissmiss,
      },
      null,
      "centroDerecha",
      true
    )(segundoModalDispatch);
  };

  useEffect(() => {
    if (
      verificaDniState.verificaDni.data !== null &&
      verificaDniState.verificaDni.data !== undefined &&
      verificaDniState.verificaDni.error === false
    ) {
      hideModal()(modalDispatch);
      setTimeout(() => {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "Solicitud correcta",
            texto:
              "Le enviaremos un mail a su casilla de correo con un token de seguridad que deberás ingresar para completar el proceso. De lo contrario, puede volver al Login para Iniciar Sesión.",
            dissmiss: cleanDni,
          },
          [
            {
              text: "Volver al login",
              clase: "btn-Mensaje b-latex30 rb16m c-latex30",
              accion: cleanDni,
            },
            {
              text: "Solicitar Token",
              clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
              accion: solicitarCodigo,
            },
          ],
          "centro",
          true
        )(modalDispatch);
      }, 250);
    } else if (
      verificaDniState.verificaDni.error !== null &&
      verificaDniState.verificaDni.error !== undefined &&
      verificaDniState.verificaDni.error.data !== "" &&
      verificaDniState.verificaDni.error.status === 400
    ) {
      //El Paciente se encuentra dado de alta en la base de datos
      showToaster(
        {
          texto: verificaDniState.verificaDni.error.data,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      if (verificaDniState.verificaDni.error.data) {
        dissmiss();
      }
    } else if (
      verificaDniState.verificaDni.error !== null &&
      verificaDniState.verificaDni.error !== undefined &&
      verificaDniState.verificaDni.error.status > 1
    ) {
      hideModal()(modalDispatch);
      setTimeout(() => {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "Dni Inexistente",
            textoNegrita: "Su DNI no se encuentra registrado!",
            texto:
              "Puede volver al login para Iniciar Sesión o Iniciar la registración de una nueva cuenta para este Dni",
            dissmiss: cleanDni,
            danger: true,
          },
          [
            {
              text: "Volver al login",
              clase: "btn-Mensaje b-latex30 cursor:pointer rb16m c-latex30",
              accion: cleanDni,
            },
            {
              text: "Iniciar Registro",
              clase: "btn-Mensaje-1 bgc-primary cursor:pointer c-white rb16m",
              accion: crearNuevaCuenta,
            },
          ],
          "centro"
        )(modalDispatch);
      }, 250);
    }
  }, [verificaDniState]);

  useEffect(() => {
    document.getElementsByName("nro_documento")[0].focus();
  }, []);

  return (
    <>
      <div className="ptur-modal-password modalHeader bgcG-latex30">
        <h1 className="modalTitle rb18b c-white">
          {titulo === "" ? "Error en el sistema" : titulo}
        </h1>
        <div className="cruz" onClick={dissmiss}>
          <div className="cruzParte1"></div>
          <div className="cruzParte2"></div>
        </div>
      </div>
      <div className="modalBody">
        <h3 className="ptur-modal-texto rb16t c-latex10">
          Por favor, ingresá tu{" "}
          <span className="rb16m"> número de documento </span> para reestablecer
          su contraseña y presione{" "}
          <span className="rb16m"> Generar nueva contraseña.</span>
        </h3>

        <div className="ptur-modal-input">
          <InputV1
            name="nro_documento"
            headerStr="Ingresá tu número de documento"
            placeholderText="12345678"
            inputType="text"
            inputMode="numeric"
            onChange={onDniChange}
            onKeyPress={onlyNumbers}
            errorStr="El valor ingresado debe ser numérico y tener al menos 7 dígitos"
            className="inputNonScroll rb16m"
            maxLength="9"
            checkError={registroState.registro.listError.nro_documento}
            isRequired={true}
            pattern="[0-9]*"
          />
        </div>
        <button className="btnCambioPassword rb18m" onClick={verificandoDni}>
          {verificaDniState.verificaDni.loading ? (
            <span>
              <IonSpinner name="lines-small" />
            </span>
          ) : (
            "Generar una nueva contraseña"
          )}
        </button>
      </div>
    </>
  );
};

export default CambioPasswordPaso1;
